import styled from 'styled-components';

import Vehicles from './container';

export default styled(Vehicles)`
  margin-top: 0.6rem;
  font-size: 1.4rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
